import LocalHospitalIcon from '@mui/icons-material/LocalHospital'
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment'
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing'
import BoltIcon from '@mui/icons-material/Bolt'

function LandingUseCases () {
  return (
    <section className='lp-use-cases-section'>
      <div className='lp-section-content'>
        <h2 className='lp-section-title'>Perfekt für Ihre Branche</h2>
        <div className='lp-use-cases-grid'>
          <div className='lp-use-case-card'>
            <div className='lp-use-case-icon'>
              <LocalHospitalIcon sx={{ fontSize: 48 }} />
            </div>
            <h3>Medizintechnik</h3>
            <p>
              Laserhersteller nutzen strukturiertes Wissen für schnelle
              Reparaturen im Außendienst.
            </p>
          </div>

          <div className='lp-use-case-card'>
            <div className='lp-use-case-icon'>
              <LocalFireDepartmentIcon sx={{ fontSize: 48 }} />
            </div>
            <h3>Heizung & Klima</h3>
            <p>
              Hersteller optimieren Service-Einsätze durch zentrales
              Troubleshooting-Wissen.
            </p>
          </div>

          <div className='lp-use-case-card'>
            <div className='lp-use-case-icon'>
              <PrecisionManufacturingIcon sx={{ fontSize: 48 }} />
            </div>
            <h3>Industrieanlagen</h3>
            <p>
              Produktionsmaschinen, Robotik, CNC-Technik – komplexe Systeme
              brauchen strukturiertes Wissen.
            </p>
          </div>

          <div className='lp-use-case-card'>
            <div className='lp-use-case-icon'>
              <BoltIcon sx={{ fontSize: 48 }} />
            </div>
            <h3>Elektrotechnik</h3>
            <p>
              Von Schaltanlagen bis Automatisierung – Fehlerdiagnosen
              schneller und sicherer durchführen.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default LandingUseCases

